<template>
  <div class="wizard-body w-full flex-shrink-0 flex-grow-0">
    <page-header
      :header-title="$t('INBOX_MGMT.ADD.ZALO_CHANNEL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.ZALO_CHANNEL.DESC')"
    />
    <form class="mx-0 flex flex-wrap" @submit.prevent="createChannel()">
      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
        <label :class="{ error: $v.channelName.$error }">
          {{ $t('INBOX_MGMT.ADD.ZALO_CHANNEL.CHANNEL_NAME.LABEL') }}
          <input
            v-model.trim="channelName"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.ZALO_CHANNEL.CHANNEL_NAME.PLACEHOLDER')
            "
            @blur="$v.channelName.$touch"
          />
          <span v-if="$v.channelName.$error" class="message">{{
            $t('INBOX_MGMT.ADD.ZALO_CHANNEL.CHANNEL_NAME.ERROR')
          }}</span>
        </label>
      </div>

      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
        <label :class="{ error: $v.oaId.$error }">
          {{ $t('INBOX_MGMT.ADD.ZALO_CHANNEL.OA_ID.LABEL') }}
          <input
            v-model.trim="oaId"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.ZALO_CHANNEL.OA_ID.PLACEHOLDER')"
            @blur="$v.oaId.$touch"
          />
        </label>
      </div>

      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
        <label :class="{ error: $v.oaAccessToken.$error }">
          {{ $t('INBOX_MGMT.ADD.ZALO_CHANNEL.OA_ACCESS_TOKEN.LABEL') }}
          <input
            v-model.trim="oaAccessToken"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.ZALO_CHANNEL.OA_ACCESS_TOKEN.PLACEHOLDER')
            "
            @blur="$v.oaAccessToken.$touch"
          />
        </label>
      </div>

      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
        <label :class="{ error: $v.refreshToken.$error }">
          {{ $t('INBOX_MGMT.ADD.ZALO_CHANNEL.REFRESH_TOKEN.LABEL') }}
          <input
            v-model.trim="refreshToken"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.ZALO_CHANNEL.REFRESH_TOKEN.PLACEHOLDER')
            "
            @blur="$v.refreshToken.$touch"
          />
        </label>
      </div>

      <div class="w-full">
        <woot-submit-button
          :loading="uiFlags.isCreating"
          :button-text="$t('INBOX_MGMT.ADD.ZALO_CHANNEL.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import { required } from 'vuelidate/lib/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';

export default {
  components: {
    PageHeader,
  },
  mixins: [alertMixin],
  data() {
    return {
      channelName: '',
      oaId: '',
      oaAccessToken: '',
      refreshToken: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    channelName: { required },
    oaId: { required },
    oaAccessToken: { required },
    refreshToken: { required },
  },
  methods: {
    async createChannel() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      try {
        const zaloChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.channelName,
            channel: {
              type: 'zalo',
              oa_id: this.oaId,
              oa_access_token: this.oaAccessToken,
              refresh_token: this.refreshToken,
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: zaloChannel.id,
          },
        });
      } catch (error) {
        this.showAlert(
          this.$t('INBOX_MGMT.ADD.ZALO_CHANNEL.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>
